import Nav from "@/components/Nav";
import Experience from "@/components/Experience";
import Footer from "@/components/Footer";

export default function ExperiencePage() {
  return (
    <>
      <Nav />
      <main>
        <Experience />
      </main>
      <Footer />
    </>
  );
}
